import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MustMatch } from 'src/services/core/helper/helper';
import { NotificationsService } from 'src/services/classes/notifications/notifications.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AccountService } from 'src/services/data/account/account.service';
import { Response } from 'src/services/classes/models/response.interface';
import { Logger } from 'src/services/core/logger/logger.service';
import { BaseButtonComponent } from 'src/app/shared/base-button/base-button.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

const log = new Logger('Change password');

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CommonModule,
    BaseButtonComponent,
  ],
})
export class ChangePasswordComponent implements OnInit {
  confirmFieldType = false;
  fieldTextType = false;
  currentFieldType = false;
  changePasswordForm!: FormGroup;

  constructor(
    private notifyService: NotificationsService,
    private accountService: AccountService,
    private fb: FormBuilder,
    private activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.initChangePasswordForm();
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  toggleCurrentPasswordFieldTextType() {
    this.currentFieldType = !this.currentFieldType;
  }

  toggleConfirmationFields() {
    this.confirmFieldType = !this.confirmFieldType;
  }

  initChangePasswordForm() {
    const pattern = '(?=.*\\d)(?=.*[a-z]).{8,100}';

    this.changePasswordForm = this.fb.group(
      {
        oldPassword: ['', Validators.required],
        newPassword: ['', [Validators.required]],
        confirmPassword: ['', Validators.required],
      },
      {
        validator: MustMatch('newPassword', 'confirmPassword'),
      }
    );
  }

  submitPasswordUpdate() {
    const payload = this.changePasswordForm.value;
    this.updatePassword(payload);
  }

  updatePassword(payload: any) {
    const changePassword$ = this.accountService.changePassword(payload);
    changePassword$.subscribe({
      next: (res: Response) => {
        if (res.status.toLowerCase() === 'success') {
          this.changePasswordForm.reset();
          res?.message
            ? this.notifyService.publishMessages(res.message, 'success', 1)
            : this.notifyService.publishMessages(
                'Password updated successfully',
                'success',
                1
              );
          this.activeModal.close(res.status);
        } else {
          res?.message
            ? this.notifyService.publishMessages(res.message, 'danger', 1)
            : this.notifyService.publishMessages(
                'An error occurred',
                'danger',
                1
              );
        }
      },
      error: (error: any) => log.debug('error: ', error),
    });
  }
}
